module.exports = __webpack_public_path__ + "media/assets/icons/gitlab-setup-90cd757e1d69a0ad211e50411f6043ed.svg";